import type { ComponentPropsWithoutRef, ReactNode, Ref } from 'react';

import { cn } from '@/lib/utils/cn';

interface ActionIconProps extends Omit<
  ComponentPropsWithoutRef<'button'>,
  'children' | 'aria-label'
> {
  ref?: Ref<HTMLButtonElement>;
  label: string;
  children: ReactNode;
  variant?: 'neutral' | 'accent';
}

/** Action compacte : libellé accessible, infobulle et finition des boutons ubeefy. */
export const ActionIcon = ({
  label,
  children,
  variant = 'neutral',
  type = 'button',
  title,
  className,
  ...rest
}: ActionIconProps) => (
  <button
    {...rest}
    type={type}
    aria-label={label}
    title={title ?? label}
    className={cn(
      'grid size-9 shrink-0 cursor-pointer place-items-center rounded-[10px] border bg-linear-to-b from-white/70 to-transparent text-[18px]',
      'shadow-[inset_0_1px_0_0_rgb(255_255_255/0.95),0_2px_4px_-1px_rgb(15_42_95/0.08)]',
      'transition-[background-color,border-color,box-shadow,color] duration-200 motion-reduce:transition-none',
      'focus-visible:ring-accent-700/25 focus-visible:ring-4 focus-visible:outline-none',
      'disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none',
      variant === 'accent'
        ? 'border-accent-200/80 bg-accent-50 text-accent-700 enabled:hover:border-accent-300 enabled:hover:bg-accent-100'
        : 'border-navy-200/80 bg-white text-navy-600 enabled:hover:border-navy-300 enabled:hover:bg-navy-50 enabled:hover:text-navy-900',
      className,
    )}
  >
    <span aria-hidden className="inline-flex">
      {children}
    </span>
  </button>
);
